export const initialValues = {
  nombreCompleto: "",
  numeroIdentidad: "",
  sexo: "",
  telefono: "",
  correoElectronico: "",
  colegio: "",
  departamentoColegio: null,
  departamentoResidencia: null,
  campusInteres: "",
  carreraInteres: "",
  nombreOtros: "",
};
